export default "__VITE_ASSET__DIipud99__"